module.exports = __webpack_public_path__ + "public/img/img_1.6d82b33f.png";